import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.487.167c-1.85 0-4.071.098-6.662.295a1.98 1.98 0 0 0-1.751 1.422l1.34.742 6.493 3.501c.19.102.376.148.578.142h.03c.202.006.389-.04.578-.142l6.494-3.501 1.345-.72A1.98 1.98 0 0 0 16.174.462C13.568.265 11.34.167 9.487.167Zm8.56 2.573-1.085.583-6.494 3.501a1.908 1.908 0 0 1-.968.237 1.905 1.905 0 0 1-.968-.237L2.038 3.323.954 2.73A39.997 39.997 0 0 0 .792 6.5c0 1.29.048 2.48.144 3.567a2.77 2.77 0 0 0 2.565 2.52c2.322.164 4.33.246 6.025.246 1.69 0 3.68-.082 5.975-.245a2.77 2.77 0 0 0 2.563-2.52c.096-1.087.144-2.276.144-3.568 0-1.368-.054-2.62-.162-3.76Z",
    fill: "currentColor"
  }));
};

var SvgEmail = styled(SvgComponent).withConfig({
  displayName: "Email__SvgEmail",
  componentId: "sc-zq8vh4-0"
})(["", " ", ""], size, color);
export default SvgEmail;